/**
 * Quem esta logado, e o que isso permite.
 */
/** Os papeis que o painel atende. Paciente usa o app, nao o HUB. */
export const HUB_ROLES = ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COMPANY_ADMIN', 'ROLE_PROFESSIONAL'];
/** Como o rotulo do papel aparece na tela, do mais forte para o mais fraco. */
export function primaryRoleLabel(roles) {
    if (roles.includes('ROLE_SUPER_ADMIN') || roles.includes('ROLE_ADMIN'))
        return 'Administrador';
    if (roles.includes('ROLE_COMPANY_ADMIN'))
        return 'Empresa';
    if (roles.includes('ROLE_PROFESSIONAL'))
        return 'Profissional';
    if (roles.includes('ROLE_PATIENT'))
        return 'Paciente';
    return 'Usuário';
}
export function hasAnyRole(roles, wanted) {
    return roles.some((role) => wanted.includes(role));
}
/** Erro que o servico levanta quando a API recusa a credencial ou o token. */
export class NotAuthenticatedError extends Error {
    constructor(message = 'Sessão expirada. Entre novamente.') {
        super(message);
        this.name = 'NotAuthenticatedError';
    }
}
//# sourceMappingURL=session.js.map